/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The kind of record a notification points at, so the client can build the route to it without
 * knowing every notification type.
 */
export enum EnumNotificationRelatedObjectType {
    /**
     * An order (Auftrag).
     */
    Order = 1,
    /**
     * An invoice (Rechnung) of the billing module.
     */
    Invoice = 2,
    /**
     * An incoming invoice snapshot shown in the invoice inbox.
     */
    InvoiceSnapshot = 3,
    /**
     * A requisition (Bestellung).
     */
    Requisition = 4,
    /**
     * A ZIP archive of printouts.
     */
    Archive = 5,
    /**
     * A run of a dynamic export, such as an Excel export.
     */
    DynamicExportRun = 6,
}
